<template>
  <TopGradientBlockLayout>
    <template v-slot:top v-if="!currentUserIsWatcher">
      <BaseButton v-if="!openForm" @click="openForm=true"
                  theme="red"
                  class="w-91">
        {{ $t('createContractor') }}
      </BaseButton>
      <ContractorsSettingsForm v-else/>
    </template>
    <ContractorsList :list="contractors"
                     @edit="setEditItem"/>
    <transition name="modal">
      <ContractorsSettingsEditModal v-if="!!edit_contractor"
                                    :edit_contractor="edit_contractor"
                                    @close="edit_contractor=null"/>
    </transition>
  </TopGradientBlockLayout>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import ContractorsSettingsForm from "@/components/cabinet/SpaceSettings/ContractorsSettings/ContractorsSettingsForm";
import ContractorsList from "@/components/cabinet/SpaceSettings/ContractorsSettings/ContractorsList";
import BaseButton from "@/components/UI/BaseButton";
import ContractorsSettingsEditModal
  from "@/components/cabinet/SpaceSettings/ContractorsSettings/ContractorsSettingsEditModal";

export default {
  name: "ContractorsSettings",
  components: {
    ContractorsSettingsEditModal,
    TopGradientBlockLayout,
    BaseButton,
    ContractorsSettingsForm,
    ContractorsList,
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapGetters('space', ['currentUserIsWatcher']),
    ...mapState('space/contractors', ['contractors']),
  },
  data() {
    return {
      openForm: false,
      edit_contractor: null,
    }
  },
  methods: {
    setEditItem(val) {
      this.edit_contractor = val;
    },
    async updateContractors() {
      await this.$store.dispatch('space/contractors/getContractors');
    },
    async fetchMainData() {
      try {
        await this.$store.dispatch('space/contractors/getContractors');
      } catch (e) {
        throw e;
      }
    },
  },
  async created() {
    await this.fetchMainData();
  },
  i18n: {
    messages: {
      en: {
        createContractor: 'Create contractor'
      },
      ru: {
        createContractor: 'Добавить контрагента'
      }
    }
  }

}
</script>

<style scoped lang="scss">
</style>
